import React from "react"
import Topic from "../../base-pages/topic"

const TopicEN = () => {
  return <Topic lang="en" />
}

export default TopicEN
